module.exports = __webpack_public_path__ + "img/re.17a4a886.png";